import { EntityKeyConfig } from '../../../types/entities';

/**
 * Entity Keys for Units
 *
 * Defines the key structure used throughout the application
 * for this entity type.
 */
export const keys: EntityKeyConfig = {
  single: 'unit',
  plural: 'units',
  state: 'units'
};